export const STATUS_CLASS_MAP: Record<string, string> = {
  ACTIVE: 'badgeSuccess',
  REVIEW_COMPLETED: 'badgeSuccess',
  IN_REVIEW: 'badgeInfo',
  INACTIVE: 'badgeNeutral',
};

export const FORMAT_CLASS_MAP: Record<string, string> = {
  DOCX: 'badgeInfo',
  PDF: 'badgeNeutral',
};
